<p [innerHTML]="visibleText" class="text-display d-inline mb-0"></p>
@if (isTextCropped()) {
  <span [innerHTML]="fadedText" class="fade-overlay"></span>
}
@if (exceedsLimit && showMoreOption) {
  <span
    (click)="toggleExtend()"
    (keydown.enter)="toggleExtend()"
    class="btn btn-link p-0 m-0 align-baseline"
    [class.ps-1]="isExpanded"
    tabindex="0"
  >{{(isExpanded ? 'common.less' : 'common.more') | cxTranslate}}</span>
}
